import { render } from "./Crime.vue?vue&type=template&id=bed784ba"
import script from "./Crime.vue?vue&type=script&lang=js"
export * from "./Crime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__